export enum ExamUnitType {
  DISTANCE = 'DISTANCE',
  POINT = 'POINT',
  REPEAT_COUNT = 'REPEAT_COUNT',
  TIME = 'TIME',
  WEIGHT = 'WEIGHT'
}
export const ExamUnitTypeTranslation = {
  [ExamUnitType.DISTANCE]: 'enum.examUnitType.distance',
  [ExamUnitType.POINT]: 'enum.examUnitType.point',
  [ExamUnitType.REPEAT_COUNT]: 'enum.examUnitType.repeat_count',
  [ExamUnitType.TIME]: 'enum.examUnitType.time',
  [ExamUnitType.WEIGHT]: 'enum.examUnitType.weight'
};

export const ExamUnitTypeScoreTranslation = {
  [ExamUnitType.DISTANCE]: 'schema.examResult.distance',
  [ExamUnitType.POINT]: 'schema.examResult.point',
  [ExamUnitType.REPEAT_COUNT]: 'schema.examResult.repeat_count',
  [ExamUnitType.TIME]: 'schema.examResult.time',
  [ExamUnitType.WEIGHT]: 'schema.examResult.weight'
};
